<template functional>
  <value-activities-info :infoData="props.row" class="my-3" />
</template>
<script>
export default {
  name: 'ActivitiesFormatter',
};
</script>
